import {
  FEATURES,
  VARIATIONS,
} from 'shared/app/components/optimizely/optimizely-keys';
import { getOptimizelyDecision } from 'shared/app/components/optimizely/get-optimizely-decision';

const isFeatureVariantEnabled = async (featureName, variationsList = []) => {
  const { isFeatureFlagEnabled, variationKey } =
    await getOptimizelyDecision(featureName);
  return Boolean(isFeatureFlagEnabled && variationsList.includes(variationKey));
};

export const isDemystifyMenuFlagEnabled = async () =>
  isFeatureVariantEnabled(FEATURES.DEMYSTIFY_MENU_PDP, [
    VARIATIONS.SHOW_MENU_AND_PDP_PRICING,
  ]);

export const isDemystifyReviewFlagEnabled = async () =>
  isFeatureVariantEnabled(FEATURES.DEMYSTIFY_REVIEW, [
    VARIATIONS.SHOW_NEW_REVIEW_PRICING,
  ]);

export const isSr6FlagEnabled = async () => {
  const { isFeatureFlagEnabled } = await getOptimizelyDecision(
    FEATURES.NEXT_GEN_LOYALTY
  );
  return isFeatureFlagEnabled;
};
